import { takeLatest } from "redux-saga/effects"
import {
  login,
  getTriviaContestList,
  deleteTriviaContestItem,
  createTrivia,
  getTriviaCategories,
  addTriviaQuestions,
  uploadQuestionImage,
  getPendingQuestions,
  approveQuestion,
  getTriviaCorrectAnswers,
  getTriviaIncorrectAnswers,
  editSuggestedQuestion,
  uploadSuggestedQuestionImage,
  getViewTriviaContestDetails,
  getViewTriviaQuestions,
  setQuestionStatusViewTrivia,
  getEditTriviaContestDetails,
  getEditTriviaQuestions,
  setQuestionStatusEditTrivia,
  editTriviaContest,
  getLeaderBoardMerchant,
  getWinnerListMerchant,
  getLeaderBoardUSerList,
  getResturantListByTrivia,
  getCorrectAnswersByTrivia,
  getIncorrectAnswersByTrivia,
  getTopSuggestorsByTrivia,
  getTopTriviaAnalytics,
  editTriviaDeleteQuestion,
  getCalendarData,
  getRestaurantsList,
  getTop5RanksTrivia,
  deleteMultipleTriviaContest,
  uploadQuestionBulk,
  getMenuDinnerLunch,
  getWineMenuItem,
  getBarMenuItem,
  generateQuestion,
  getQuestionsBank,
  addToQuestionBank,
  addManualQuestionToBank,
  getTriviaMonthList,
  addQuestionToTrivia,
  getAutoSuggestQuestions,
  getMenuDinnerLunchSearch,
  deleteQuestionFromBank,
  getGenerateQuestionsSpirits,
  getAllQuestionsByTrivia,
  deleteQuestionFromAutoSuggest,
  getIncorrectTriviaContestList,
  getIncorrectTriviaDuration,
  getCategoryCount
} from "./user"
import {
  loginAction,
  getTriviaContestListAction,
  deleteTriviaContestItemAction,
  createTriviaAction,
  getTriviaCategoriesAction,
  addTriviaQuestionsAction,
  uploadQuestionImageAction,
  getPendingQuestionsAction,
  approveQuestionAction,
  getTriviaCorrectAnswersAction,
  getTriviaIncorrectAnswersAction,
  editSuggestedQuestionAction,
  uploadSuggestedQuestionImageAction,
  getViewTriviaContestDetailsAction,
  getViewTriviaQuestionsAction,
  setQuestionStatusViewTriviaAction,
  getLeaderBoardMerchantAction,
  getLeaderBoardUserListAction,
  getResturantListByTriviaAction,
  getCorrectAnswersByTriviaAction,
  getIncorrectAnswersByTriviaAction,
  getTopSuggestorsByTriviaAction,
  editTriviaDeleteQuestionAction,
  getCalendarDataAction,
  getAllQuestionsByTriviaAction,
  getIncorrectTriviaContestListAction,
  getIncorrectTriviaDurationAction,
  getCategoryCountAction
} from "../actions/index"
import {
  deleteMultipleTriviaContestAction,
  editTriviaContestAction,
  getEditTriviaContestDetailsAction,
  getEditTriviaQuestionsAction,
  getRestaurantsListAction,
  getTop5RanksTriviaAction,
  getTopTriviaAnalyticsAction,
  getWinnerListMerchantAction,
  setQuestionStatusEditTriviaAction,
  uploadQuestionBulkAction,
  getMenuDinnerLunchAction,
  getWineMenuItemAction,
  getBarMenuItemAction,
  generateQuestionAction,
  getQuestionsBankAction,
  addToQuestionBankAction,
  addManualQuestionToBankAction,
  getTriviaMonthListAction,
  addQuestionToTriviaAction,
  getAutoSuggestQuestionsAction,
  getMenuDinnerLunchSearchAction,
  deleteQuestionFromBankAction,
  getGenerateQuestionsSpiritsAction,
  deleteQuestionFromAutoSuggestAction
} from "../actions/user"

export default function* L_D_actionWatcher() {
  yield takeLatest(loginAction, login)
  yield takeLatest(getTriviaContestListAction, getTriviaContestList)
  yield takeLatest(deleteTriviaContestItemAction, deleteTriviaContestItem)
  yield takeLatest(createTriviaAction, createTrivia)
  yield takeLatest(getTriviaCategoriesAction, getTriviaCategories)
  yield takeLatest(addTriviaQuestionsAction, addTriviaQuestions)
  yield takeLatest(uploadQuestionImageAction, uploadQuestionImage)
  yield takeLatest(getPendingQuestionsAction, getPendingQuestions)
  yield takeLatest(approveQuestionAction, approveQuestion)
  yield takeLatest(getTriviaCorrectAnswersAction, getTriviaCorrectAnswers)
  yield takeLatest(getTriviaIncorrectAnswersAction, getTriviaIncorrectAnswers)
  yield takeLatest(editSuggestedQuestionAction, editSuggestedQuestion)
  yield takeLatest(uploadSuggestedQuestionImageAction, uploadSuggestedQuestionImage)
  yield takeLatest(getViewTriviaContestDetailsAction, getViewTriviaContestDetails)
  yield takeLatest(getViewTriviaQuestionsAction, getViewTriviaQuestions)
  yield takeLatest(setQuestionStatusViewTriviaAction, setQuestionStatusViewTrivia)
  yield takeLatest(getEditTriviaContestDetailsAction, getEditTriviaContestDetails)
  yield takeLatest(getEditTriviaQuestionsAction, getEditTriviaQuestions)
  yield takeLatest(setQuestionStatusEditTriviaAction, setQuestionStatusEditTrivia)
  yield takeLatest(editTriviaContestAction, editTriviaContest)

  yield takeLatest(getLeaderBoardMerchantAction, getLeaderBoardMerchant)
  yield takeLatest(getWinnerListMerchantAction, getWinnerListMerchant)
  yield takeLatest(getLeaderBoardUserListAction, getLeaderBoardUSerList)

  yield takeLatest(getResturantListByTriviaAction, getResturantListByTrivia)
  yield takeLatest(getCorrectAnswersByTriviaAction, getCorrectAnswersByTrivia)
  yield takeLatest(getIncorrectAnswersByTriviaAction, getIncorrectAnswersByTrivia)
  yield takeLatest(getTopSuggestorsByTriviaAction, getTopSuggestorsByTrivia)
  yield takeLatest(getTopTriviaAnalyticsAction, getTopTriviaAnalytics)
  yield takeLatest(editTriviaDeleteQuestionAction, editTriviaDeleteQuestion)
  yield takeLatest(getCalendarDataAction, getCalendarData)
  yield takeLatest(getRestaurantsListAction, getRestaurantsList)
  yield takeLatest(getTop5RanksTriviaAction, getTop5RanksTrivia)
  yield takeLatest(uploadQuestionBulkAction, uploadQuestionBulk)
  yield takeLatest(deleteMultipleTriviaContestAction, deleteMultipleTriviaContest)
  yield takeLatest(getMenuDinnerLunchAction, getMenuDinnerLunch)
  yield takeLatest(getWineMenuItemAction, getWineMenuItem)
  yield takeLatest(getBarMenuItemAction, getBarMenuItem)
  yield takeLatest(generateQuestionAction, generateQuestion)
  yield takeLatest(getQuestionsBankAction, getQuestionsBank)
  yield takeLatest(addToQuestionBankAction, addToQuestionBank)
  yield takeLatest(addManualQuestionToBankAction, addManualQuestionToBank)
  yield takeLatest(getTriviaMonthListAction, getTriviaMonthList)
  yield takeLatest(addQuestionToTriviaAction, addQuestionToTrivia)
  yield takeLatest(getAutoSuggestQuestionsAction, getAutoSuggestQuestions)
  yield takeLatest(getMenuDinnerLunchSearchAction, getMenuDinnerLunchSearch)
  yield takeLatest(deleteQuestionFromBankAction, deleteQuestionFromBank)
  yield takeLatest(getGenerateQuestionsSpiritsAction, getGenerateQuestionsSpirits)
  yield takeLatest(getAllQuestionsByTriviaAction, getAllQuestionsByTrivia)
  yield takeLatest(deleteQuestionFromAutoSuggestAction, deleteQuestionFromAutoSuggest)
  yield takeLatest(getIncorrectTriviaContestListAction, getIncorrectTriviaContestList)
  yield takeLatest(getIncorrectTriviaDurationAction, getIncorrectTriviaDuration)
  yield takeLatest(getCategoryCountAction, getCategoryCount)
}
